export { default as LifestylesMaterialsFilter } from './LifestylesMaterialsFilter';
